import React from 'react'
import { css } from '@linaria/core'
import { Person } from '@fs/zion-person'
import { useOverlay, colors } from '@fs/zion-ui'
import { boolAttr } from '@fs/zion-frontend-friends'

const itemContainerCss = css`
  padding: 0 12px;
  height: 54px;
  display: flex;
  align-items: center;

  & > div {
    min-width: 0;
  }
`

const customPersonCss = css`
  border-radius: 4px;
  /* This negative margin follows the same pattern used in zion-ui's ListItem */
  margin: 0 -12px;
  &[highlight] {
    background-color: ${colors.gray05};
  }

  &:hover {
    background-color: ${colors.transparent.gray03};
    cursor: pointer;
  }
`

export default function CustomPerson({
  person,
  showGenderText,
  hidePids: hidePid,
  customPersonLinkOrOverlay,
  highlight,
}) {
  const CustomPersonOverlay = customPersonLinkOrOverlay
  const overlay = useOverlay()

  const personProps = {
    personObj: person,
    hidePid,
    showGenderText,
    avatarSize: 'smaller',
  }

  const clickHandler = (event) => {
    // If the person had a customPersonLink, use that first.
    // If not, but they had an overlay and used `customPersonLinkOrOverlay`, we open the overlay.
    // Otherwise, we default to normal Person behavior.
    if (person?.customPersonLink) {
      event.preventDefault()
      event.stopPropagation()
      // eslint-disable-next-line no-template-curly-in-string -- We want to replace ${pid}; it is part of the string
      window.location.href = person.customPersonLink.replace('${pid}', person.id)
    } else if (customPersonLinkOrOverlay) {
      event.preventDefault()
      event.stopPropagation()
      overlay.handleClick(event)
    }
  }

  return (
    <>
      <div
        className={customPersonCss}
        highlight={boolAttr(highlight)}
        key={person.id}
        onClick={clickHandler}
        onKeyDown={(e) => {
          if (/(^Enter$)|(^NumpadEnter$)/.test(e.key)) clickHandler(e)
        }}
        role="button"
        tabIndex="0"
        data-testid="custom-person-item"
      >
        <div className={itemContainerCss}>
          <Person {...personProps} />
        </div>
      </div>
      {CustomPersonOverlay && <CustomPersonOverlay person={person} overlay={overlay} />}
    </>
  )
}
